export default __webpack_public_path__ + "static/media/clear-rush-logo.d54d2963.png";